
import { Component, Vue, Watch } from "vue-property-decorator";
import SuccessPopup from "./popups/SuccessPopup.vue";
import CouponPopup from "./popups/CouponPopup.vue";
import { ICoupon } from "../../../store/interfaces/coupon";

@Component({
  name: "PopupContainer",
  components: {
    SuccessPopup,
    CouponPopup
  }
})
export default class PopupContainer extends Vue {
  name: string = "";
  data: ICoupon;

  @Watch("$store")
  created() {
    const popupState = this.$store.getters["app/popup"];
  }

  handleNotPopupClick(e) {
    if (e.target["classList"].contains("popup-wrap")) {
      window.removeEventListener("click", this.handleNotPopupClick, true);
      this.handleClick();
    }
  }

  get isOpen() {
    const popupState = this.$store.getters["app/popup"];
    this.name = popupState.name;
    this.data = popupState.data;
    if (popupState.isOpen) {
      window.addEventListener("click", this.handleNotPopupClick, true);
    }
    return popupState.isOpen;
  }

  handleClick() {
    this.$store.dispatch("app/togglePopupAction");
  }
}
